export class CreateIngestionPipelineInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespace",
            "baseName": "namespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "IngestionSourceType",
            "format": ""
        },
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": ""
        },
        {
            "name": "s3SourceProperties",
            "baseName": "s3SourceProperties",
            "type": "S3SourceProperties",
            "format": ""
        },
        {
            "name": "gcsSourceProperties",
            "baseName": "gcsSourceProperties",
            "type": "GcsSourceProperties",
            "format": ""
        },
        {
            "name": "kafkaSourceProperties",
            "baseName": "kafkaSourceProperties",
            "type": "KafkaSourceProperties",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateIngestionPipelineInput.attributeTypeMap;
    }
    constructor() {
    }
}
